var token = null;
var logged = false;

function getToken() {
  return new Promise((resolve, reject) => {
    if (token === null) {
      let v = localStorage.getItem('token');
      if (v) {
        token = v;
        logged = true;
        resolve(token);
      } else {
        logged = false;
        resolve(token);
      };
    } else {
      if (token) {
        logged = true;
        resolve(token);
      } else {
        logged = false;
        token ? reject(token) : resolve(token);
      }
    }
  });
}

function setToken(access) {
  return new Promise((resolve, reject) => {
    if (access) {
      token = access;
      localStorage.setItem('token', access);
      logged = true;
      resolve();
    } else {
      token = '';
      logged = false;
      reject();
    }
  });
}

function delToken() {
  token = '';
  logged = false;
  return localStorage.removeItem('token');
}

function hasLoggedIn() {
  return logged;
}

export { hasLoggedIn, getToken, setToken, delToken };
